import { Expose } from "class-transformer";

export class CreateClientConditionCodeDto {
  @Expose()
  code: string;

  @Expose()
  days: number;
}
